import React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import useAuth from 'hooks/useAuth';
import { getClient } from 'graphql/client';

interface Props {
  children: React.ReactElement;
}

const GraphqlProvider: React.SFC<Props> = (props) => {
  const { children } = props;
  const { token } = useAuth();

  const client = getClient(token);

  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  );
}

export default GraphqlProvider;
